import { createFileRoute } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-session";
import { EmailCampaignList } from "@/components/email/EmailCampaignList";

export const Route = createFileRoute("/_app/_/email/")({
	component: EmailIndexPage,
});

function EmailIndexPage() {
	const session = useSession();
	const campaignId = session.campaign?.id;

	if (!campaignId) {
		return (
			<div className="flex min-h-[50vh] items-center justify-center">
				<p className="text-muted-foreground">Loading campaign...</p>
			</div>
		)
	}

	return (
		<div className="min-h-screen bg-muted/30 p-6">
			<div className="mx-auto max-w-7xl space-y-6">
				<div>
					<h1 className="text-3xl font-bold">Email Campaigns</h1>
					<p className="text-muted-foreground">
						Create and send emails to your supporters
					</p>
				</div>
				<EmailCampaignList campaignId={campaignId} />
			</div>
		</div>
	)
}
